// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3-spi","header":"MergedInvoice_header__311-A"};